import type { ResourceDescriptor } from '@/services/uiActions/resources'
import { requireResourceId } from '@/services/uiActions/resources'
import { userTool, userToolNew, userToolsList } from '@constants/routing'

export const userToolResource: ResourceDescriptor = {
  kind: 'userTool',
  routes: {
    ui_open_user_tools: () => userToolsList(),
    ui_open_user_tool: operation => userTool(requireResourceId(operation)),
    ui_create_user_tool: () => userToolNew(),
    ui_update_user_tool: operation => userTool(requireResourceId(operation)),
    ui_delete_user_tool: operation => userTool(requireResourceId(operation)),
  },
}
